import { Footer, Header, Main, SEO, Subnav } from '@/components';

export function GlobalElements({ children, siteTitle, siteDescription, seo, featuredImageUrl, headerMenuItems, navigationSettings, footerMenuItems, subnavMenuItems, disclosures, pageTitle }) {
	return (
		<>
			<SEO siteTitle={siteTitle} siteDescription={siteDescription} seo={seo} imageUrl={featuredImageUrl} pageTitle={pageTitle} />
			<Header title={siteTitle} menuItems={headerMenuItems} navigationSettings={navigationSettings} />
			{subnavMenuItems && <Subnav menuItems={subnavMenuItems} navigationSettings={navigationSettings} />}
			<Main>{children}</Main>
			<Footer siteDescription={siteDescription} menuItems={footerMenuItems} disclosures={disclosures} />
		</>
	);
}
